import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import _ from 'lodash'

import { FormattedMessage, injectIntl } from 'react-intl'

import BisnodeScoringComponent from '../../BisnodeScoring'

import config from '../../../../../../../../../config'

import hocBlock from '../../../../../../../components/Workspace/components/HocBlock'

import { LOCALE_PREFIX } from './constants'

@hocBlock(config.modules.report.key, { levelReload: true })
@injectIntl
export default class BisnodeScoring extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        data: PropTypes.array,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object.isRequired,
        level: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        transformedData: PropTypes.object,
        customData: PropTypes.object,
        saveCustomData: PropTypes.func,
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.level !== nextProps.level) return true
        if (this.props.id !== nextProps.id) return true
        if (!_.isEqual(this.props.data, nextProps.data)) return true
        if (!_.isEqual(this.props.transformedData, nextProps.transformedData)) return true
        if (!_.isEqual(this.props.customData, nextProps.customData)) return true

        return false
    }

    render() {
        const {
            data,
            intl: { formatMessage },
            module,
            block,
            level,
            id,
            transformedData,
            customData,
            saveCustomData,
        } = this.props

        return (
            <div className={cx('block-bisnode-scoring')}>
                <BisnodeScoringComponent
                    data={transformedData?.summary?.data}
                    legend={transformedData?.summary?.legend}
                    chartData={transformedData?.chart?.data || []}
                    scoringDegrees={transformedData?.scoringDegrees || []}
                    originalData={data}
                    module={module}
                    block={block}
                    level={level}
                    id={id}
                    customData={customData}
                    saveCustomData={saveCustomData}
                    translates={{
                        degreeLabel: formatMessage({ id: `${LOCALE_PREFIX}.bisnodeScoring.degreeLabel` }),
                        descriptionLabel: formatMessage({ id: `${LOCALE_PREFIX}.bisnodeScoring.descriptionLabel` }),
                        probabilityLabel: (
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.bisnodeScoring.probabilityLabel`}
                                values={{ br: <br /> }}
                            />
                        ),
                        terminologyToggleText: formatMessage({
                            id: `${LOCALE_PREFIX}.bisnodeScoring.terminologyToggleText`,
                        }),
                        terminologyScoringText: (
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.bisnodeScoring.terminologyScoringText`}
                                values={{
                                    br: <br />,
                                    strong: (chunks) => <strong>{chunks}</strong>,
                                    privCz: (chunks) => (
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="link"
                                            href="https://dnb.com/cs-cz/privacy/dokumenty"
                                        >
                                            {chunks}
                                        </a>
                                    ),
                                    privSk: (chunks) => (
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="link"
                                            href="https://www.dnb.com/sk-sk/privacy/dokumenty"
                                        >
                                            {chunks}
                                        </a>
                                    ),
                                }}
                            />
                        ),
                        terminologyKreditText: (
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.bisnodeScoring.terminologyKreditText`}
                                values={{
                                    br: <br />,
                                    strong: (chunks) => <strong>{chunks}</strong>,
                                    privCz: (chunks) => (
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="link"
                                            href="https://dnb.com/cs-cz/privacy/dokumenty"
                                        >
                                            {chunks}
                                        </a>
                                    ),
                                    privSk: (chunks) => (
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="link"
                                            href="https://www.dnb.com/sk-sk/privacy/dokumenty"
                                        >
                                            {chunks}
                                        </a>
                                    ),
                                }}
                            />
                        ),
                        terminologyTransactionText: (
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.bisnodeScoring.terminologyTransactionText`}
                                values={{
                                    br: <br />,
                                    strong: (chunks) => <strong>{chunks}</strong>,
                                    privCz: (chunks) => (
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="link"
                                            href="https://dnb.com/cs-cz/privacy/dokumenty"
                                        >
                                            {chunks}
                                        </a>
                                    ),
                                    privSk: (chunks) => (
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="link"
                                            href="https://www.dnb.com/sk-sk/privacy/dokumenty"
                                        >
                                            {chunks}
                                        </a>
                                    ),
                                }}
                            />
                        ),
                        terminologyLimitsText: (
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.bisnodeScoring.terminologyLimitsText`}
                                values={{
                                    br: <br />,
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        ),
                        creditsLimitText: formatMessage({ id: `${LOCALE_PREFIX}.bisnodeScoring.creditsLimitText` }),
                        transactionsLimitText: formatMessage({
                            id: `${LOCALE_PREFIX}.bisnodeScoring.transactionsLimitText`,
                        }),
                        criteriaText: (
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.bisnodeScoring.criteriaText`}
                                values={{
                                    br: <br />,
                                    a: (chunks) => (
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href="http://www.eulerhermes.cz/"
                                            className="link"
                                        >
                                            {chunks}
                                        </a>
                                    ),
                                }}
                            />
                        ),
                        criteriaTitleText: formatMessage({ id: `${LOCALE_PREFIX}.bisnodeScoring.criteriaTitleText` }),
                        refreshText: <FormattedMessage id={`${LOCALE_PREFIX}.bisnodeScoring.refreshText`} />,
                        lastChangeText: formatMessage({ id: `${LOCALE_PREFIX}.bisnodeScoring.lastChangeText` }),
                        yearOfFinancialStatements: (
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.bisnodeScoring.yearOfFinancialStatements`}
                                values={{ year: transformedData?.summary?.data?.financialStatementsYear }}
                            />
                        ),
                        noData: <FormattedMessage id={`${LOCALE_PREFIX}.noData`} />,
                    }}
                />
            </div>
        )
    }
}
